module.exports = {
      id: "default-author-usage",
      viewBox: "0 0 122 120",
      url: __webpack_public_path__ + "svg-sprite-b11c226f9ecc9a258e9645c9abf2e2fd.svg#default-author",
      toString: function () {
        return this.url;
      }
    }